import { CircularProgress } from "material-ui";

const CENTERED_STYLE = {
  margin: "0 auto",
  textAlign: "center"
};

const FULL_PAGE_STYLE = {
  margin: "0 auto",
  padding: 10,
  textAlign: "center"
};

const FULL_PAGE_PROPS = {
  size: 1.5
};

const OVERLAY_STYLE = {
  position: "fixed",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2
};

export default ({ style, fullPage, centered, overlay, ...rest }) => {
  if (fullPage) {
    rest = Object.assign({}, FULL_PAGE_PROPS, rest);
  }

  return (
    <div
      style={Object.assign(
        {},
        centered && CENTERED_STYLE,
        fullPage && FULL_PAGE_STYLE,
        overlay && OVERLAY_STYLE,
        style
      )}
    >
      <CircularProgress mode="indeterminate" {...rest} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/working-indicator.jsx